module.exports = __webpack_public_path__ + "img/error-form.18f8a13a.svg";